export const themeSamples = [
  {
    name: "Editorial Serif & Deep Oxblood",
    rationale:
      "Inspired by Studio Freight and Pentagram institutional identities. High-contrast editorial serif display paired with clean grotesque body typography. Light warm alabaster canvas paired with deep oxblood and forest cypress accents for intellectual authority and human warmth.",
    tokens: {
      bg: "#FAF8F5",
      surface: "#FFFFFF",
      text: "#141210",
      textMuted: "#6B655F",
      brand: "#581820",
      accent: "#2D4A3E",
      border: "#E6E2DC",
      btnPrimaryBg: "#141210",
      btnPrimaryText: "#FAF8F5",
      btnSecondaryBorder: "#141210",
      btnSecondaryText: "#141210",
    },
    fonts: {
      display: "Instrument Serif",
      body: "Plus Jakarta Sans",
      importUrl:
        "https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap",
    },
    behavior: {
      radius: "0px",
      buttonStyle:
        "Sharp 0px corner, high-contrast monochrome fill with 1px inset hairline border, uppercase tracking-[0.15em] typography.",
      rules:
        "0.5px subtle horizontal hairlines separating content sections and metadata grids, reminiscent of Swiss print layout.",
      accentUsage:
        "Oxblood used strictly for section eyebrow badges, active tab markers, and primary callout borders. Deep Cypress used sparingly on status badges and quotes.",
    },
  },
  {
    name: "International Modernist Cobalt",
    rationale:
      "Drawing directly from Area 17 and Swiss modernist studio systems. Replaces generic navy with an intense Ultramarine Cobalt on cool architectural chalk. Strict high-density grid lines, precise 4px radii, and stark typographic contrast.",
    tokens: {
      bg: "#F4F5F7",
      surface: "#FFFFFF",
      text: "#0D1117",
      textMuted: "#57606A",
      brand: "#1230AE",
      accent: "#007A5E",
      border: "#D8DEE4",
      btnPrimaryBg: "#1230AE",
      btnPrimaryText: "#FFFFFF",
      btnSecondaryBorder: "#0D1117",
      btnSecondaryText: "#0D1117",
    },
    fonts: {
      display: "Chivo",
      body: "Manrope",
      importUrl:
        "https://fonts.googleapis.com/css2?family=Chivo:wght@700;800;900&family=Manrope:wght@400;500;600&display=swap",
    },
    behavior: {
      radius: "4px",
      buttonStyle:
        "Controlled 4px precise radius with solid fill, bold geometric weight, and micro-hover translation with crisp shadow drop.",
      rules:
        "1px solid slate rules bounding top and bottom of feature cards; grid lines exposed between bento modules.",
      accentUsage:
        "Cobalt anchors high-priority CTAs and brand indicators. Emerald green is reserved exclusively for live metric badges, interactive status pills, and focus ring states.",
    },
  },
  {
    name: "Pan-African Heritage Ochre",
    rationale:
      "A warm, institutional heritage direction honoring West African craftsmanship and geometry (Ghana & Côte d'Ivoire). Merges soft bone linen canvas with rich burnt terracotta ochre, deep Sahel forest green, and architectural display typography.",
    tokens: {
      bg: "#F5F2EB",
      surface: "#FFFFFF",
      text: "#1A1816",
      textMuted: "#6B645C",
      brand: "#A24813",
      accent: "#1E4A38",
      border: "#E2DCD3",
      btnPrimaryBg: "#1A1816",
      btnPrimaryText: "#F5F2EB",
      btnSecondaryBorder: "#A24813",
      btnSecondaryText: "#A24813",
    },
    fonts: {
      display: "Syne",
      body: "Outfit",
      importUrl:
        "https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=Outfit:wght@400;500;600&display=swap",
    },
    behavior: {
      radius: "0px",
      buttonStyle:
        "Architectural 0px box with solid contrast fill, subtle 1px border shift on hover, and wide tracking labels.",
      rules:
        "Tactile double-hairline section dividers and rich border framing on bento containers, creating physical document structure.",
      accentUsage:
        "Burnt Ochre Terracotta highlights structural headlines, key CTA borders, and regional statistics. Sahel Green is deployed for bilingual indicators (EN/FR toggle) and secondary accreditation badges.",
    },
  },
];
